import { DescriptionDetails, DescriptionList, DescriptionListItem, DescriptionTerm, Field as KitField, Hint, Label } from '@d-edge/overnight-hotelier-react'
import type { ReactNode } from 'react'
import styles from './ui.module.css'

interface FieldProps {
  label: ReactNode
  hint?: ReactNode
  /** Validation message; replaces the hint and is styled as an error. */
  error?: ReactNode
  required?: boolean
  children: ReactNode
  /** Only needed for native controls; kit controls are wired to the label by the field context. */
  htmlFor?: string
  className?: string
}

export function Field({ label, hint, error, required, children, htmlFor, className }: FieldProps) {
  return (
    <KitField required={required} className={`${styles.field} ${className ?? ''}`}>
      <Label {...(htmlFor ? { htmlFor } : {})}>{label}</Label>
      {children}
      {error ? <Hint state="error">{error}</Hint> : hint ? <Hint>{hint}</Hint> : null}
    </KitField>
  )
}

export function KeyValueList({ items }: { items: { label: string; value: ReactNode }[] }) {
  return (
    <DescriptionList layout="two-columns" className={styles.kv}>
      {items.map((item) => (
        <DescriptionListItem key={item.label}>
          <DescriptionTerm>{item.label}</DescriptionTerm>
          <DescriptionDetails>{item.value}</DescriptionDetails>
        </DescriptionListItem>
      ))}
    </DescriptionList>
  )
}
